import { CommonModule } from '@angular/common';
import { Component, Input} from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-sidenav-mobile-control',
  templateUrl: './sidenav-mobile-control.component.html',
  styleUrls: ['./sidenav-mobile-control.component.scss'],
  imports: [
      CommonModule,
      SharedModule
    ],
  standalone: true
})
export class SidenavMobileControlComponent {
  @Input() drawer: any;
}
